import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 98D7A146-D68E-4E80-B8F1-5235DAECD976
 * name power-socket-jp
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket-jp.svg
 * tags
 * - Home Automation 
 */
export const PowerSocketJpIcon = createSvgIcon(<><path d="M10 9.5V14.5H8V9.5M19.78 2C21 2 22 3 22 4.22V19.78C22 21 21 22 19.78 22H4.22C3 22 2 21 2 19.78V4.22C2 3 3 2 4.22 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M16 9.5V14.5H14V9.5Z" /></>, 'PowerSocketJpIcon');
export default PowerSocketJpIcon